import groupService from '../services/groups';

const groupReducer = (state = null, action) => {
  switch (action.type) {
    case 'SET_ALL_GROUPS_LIST':
      return { ...state, allGroups: action.payload };
    case 'SET_TOP_GROUPS_LIST':
      return { ...state, topGroups: action.payload };
    case 'SUBSCRIBE_GROUP_FROM_LIST':
      return {
        ...state,
        topGroups: state.topGroups.map((t) =>
          t.id !== action.payload.id ? t : { ...t, ...action.payload.data }
        ),
      };
    case 'ADD_NEW_GROUP':
      return {
        ...state,
        allGroups: [...state.allGroups, action.payload],
      };
    case 'DELETE_PEEKGROUP':
      return {
        ...state,
        allGroups: state.allGroups.filter(group => group.id !== action.payload), // Remove peekgroup by ID
      };
    default:
      return state;
  }
};

export const setGroupList = () => {
  return async (dispatch) => {
    const groups = await groupService.getAllPeekgroups();

    dispatch({
      type: 'SET_ALL_GROUPS_LIST',
      payload: groups,
    });
  };
};

export const setTopGroupsList = () => {
  return async (dispatch) => {
    const top10Groups = await groupService.getTopPeekgroups();

    dispatch({
      type: 'SET_TOP_GROUPS_LIST',
      payload: top10Groups,
    });
  };
};

export const toggleSubscribe = (id, subscribedBy) => {
  return async (dispatch) => {
    const subscriberCount = subscribedBy.length;

    dispatch({
      type: 'SUBSCRIBE_GROUP_FROM_LIST',
      payload: { id, data: { subscribedBy, subscriberCount } },
    });

    await groupService.subscribeGroup(id);
  };
};

export const addNewGroup = (peekgroupObj) => {
  return async (dispatch) => {
    const createdGroup = await groupService.createPeekgroup(peekgroupObj);

    dispatch({
      type: 'ADD_NEW_GROUP',
      payload: {
        peekgroupName: createdGroup.peekgroupName,
        id: createdGroup.id,
      },
    });
  };
};

// New action for deleting a peekgroup
export const deletePeekgroup = (id) => async (dispatch) => {
  try {
    await groupService.deletePeekgroup(id); // Call to your backend API to delete the peekgroup

    dispatch({
      type: 'DELETE_PEEKGROUP',
      payload: id, // Pass the peekgroup ID to be removed
    });
  } catch (error) {
    console.error('Error deleting peekgroup:', error);
  }
};

export default groupReducer;
